import React, { PureComponent } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";

import Button from "../../Common/Button";
import PanelMobileContextMenuButtons from "./PanelMobileContextMenuButtons";

export default class PanelMobileContextMenu extends PureComponent {
  static propTypes = {
    actions: PropTypes.array,
    className: PropTypes.string
  };

  static defaultProps = {
    actions: [],
    className: ""
  };

  state = {
    isMenuOpen: false
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClick, false);
    document.addEventListener("touchmove", this.handleClick, false);
    document.addEventListener("scroll", this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick, false);
    document.removeEventListener("touchmove", this.handleClick, false);
    document.removeEventListener("scroll", this.handleClick, false);
  }

  handleClick = e => {
    if (this.settings) {
      const isClickOutsideSettings = !this.settings.contains(e.target);

      if (isClickOutsideSettings) {
        this.setState({ isMenuOpen: false });
      }
    }
  };

  handleMenuClick = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  render() {
    return (
      !_.isEmpty(this.props.actions) && (
        <div
          ref={settings => {
            this.settings = settings;
          }}
          className={classNames("panel-header__mobile-menu", this.props.className)}>
          <Button className="panel-header__mobile-menu-icon" icon="ellipsis" onClick={this.handleMenuClick} />
          {this.state.isMenuOpen && <PanelMobileContextMenuButtons actions={this.props.actions} />}
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/PanelMobileContextMenu.js